// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.demo {
    background-image: url(https://www.zazmic.com/wp-content/themes/zazmic/img/bg.png);
    padding: 60px 0 50px 0;
  }
  .demo__container{
      width: 1200px;
      margin: 0 auto;
      max-width: 100%;
      height: 100%;
      display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .demo__title {
    color: #1e1c1a;
    font-family: Roboto;
    font-size: 36px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 47px;
    margin-bottom: 35px;
    text-align: center;
  }
  
    
   
  `, "",{"version":3,"sources":["webpack://./src/components/DemoVideo/DemoVideo.css"],"names":[],"mappings":"AAAA;IACI,iFAAiF;IACjF,sBAAsB;EACxB;EACA;MACI,aAAa;MACb,cAAc;MACd,eAAe;MACf,YAAY;MACZ,aAAa;IACf,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB","sourcesContent":[".demo {\n    background-image: url(https://www.zazmic.com/wp-content/themes/zazmic/img/bg.png);\n    padding: 60px 0 50px 0;\n  }\n  .demo__container{\n      width: 1200px;\n      margin: 0 auto;\n      max-width: 100%;\n      height: 100%;\n      display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  .demo__title {\n    color: #1e1c1a;\n    font-family: Roboto;\n    font-size: 36px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 47px;\n    margin-bottom: 35px;\n    text-align: center;\n  }\n  \n    \n   \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
